import constants from "constants/constants";
import { PAYMENT_DEBIT_MODES_LABELS } from "features/Listings/modules/PricingSection/PricingSection.constants";
import moment from "moment";
import {
  DISPUTE_HISTORY_TAB,
  field_data,
  FILTERS_OPTIONS_PLACEHOLDERS,
  form_data,
  listingTypeOptions,
  ORDER_PAYMENT_TYPE_FILTER_CHIPS_LABELS,
  QR_PAYMENTS_TAB,
  REFUND_HISTORY_TAB,
  tab_config,
} from "ui/pages/transactions/AllTransaction/AllTransactionTableConfig";
import {
  GATEWAY_TYPE_OPTIONS_MAP,
  TRANSACTION_TYPE_ENUM,
} from "../Transactions.constants";
import { isInternationalTimezone } from "utils/AuthUtil";
import { GATEWAY_NUMBER_STRING } from "features/Account/modules/PaymentOptions/constants/PaymentOptions.constants";
import { is_empty } from "features/Common/utils/common.utils";
import { question_type_id } from "constants/customerQuestions.constants";

/**
 * Checks if a transaction is a cash booking transaction.
 * @param {number} transactionType - The type of transaction to check.
 * @returns {boolean} Returns true if the transaction type is 'offline'; otherwise, returns false.
 */
export const isCashBookingTransaction = (transactionType) =>
  transactionType === TRANSACTION_TYPE_ENUM.offline;

export const formatGuestName = (value) => `${form_data.name}: ${value}`;

export const formatGuestEmail = (value) => `${form_data.email}: ${value}`;

export const formatListingTitle = (value) =>
  `${form_data.session_name}: ${value}`;

export const formatOfferingVariation = (value) =>
  `${form_data.offeringVariation.label}: ${value}`;

export const formatGuestPhoneNumber = (value) => `${form_data.phone}: ${value}`;

export const formatMinPrice = (value) => `${form_data.min_price}: ${value}`;

export const formatMaxPrice = (value) => `${form_data.max_price}: ${value}`;

export const formatListingType = (value) => {
  const listing = listingTypeOptions?.find((item) => item.id == value);
  return `Offering Type: ${listing?.name}`;
};

export const formatListingId = (value) => {
  return `Offering Id: ${value}`;
};

export const formatPaymentType = (value) =>
  `${form_data.payment_plan_type}: ${ORDER_PAYMENT_TYPE_FILTER_CHIPS_LABELS[value]}`;

export const formatPaymentDebitMode = (value) =>
  `${form_data.payment_debit_mode}: ${PAYMENT_DEBIT_MODES_LABELS[value]}`;

export const formatOrgUuid = (staffMembers) => (value) => {
  const staff = staffMembers?.find((item) => item.id == value);
  return `${form_data.staff}: ${staff?.name}`;
};

export const formatStartDate = (value) => {
  if (!value) return "N/A";
  return `${form_data.start_date}: ${moment(value).format(
    constants.displayDateYearFormat
  )}`;
};

export const formatEndDate = (value) => {
  if (!value) return "N/A";
  return `${form_data.end_date}: ${moment(value).format(
    constants.displayDateYearFormat
  )}`;
};

export const formatTransactionId = (value) =>
  `${FILTERS_OPTIONS_PLACEHOLDERS[field_data.transaction_id]}: ${value}`;

export const formatGatewayType = (value) =>
  `${FILTERS_OPTIONS_PLACEHOLDERS[field_data.gateway_type]}: ${
    GATEWAY_TYPE_OPTIONS_MAP[value].label
  }`;

export const getTransactionsTabConfig = ({
  isWalletActive,
  isQrPaymentsEnabled = true,
} = {}) => {
  const isInternational = isInternationalTimezone();
  const tabConfig = [...tab_config];

  if (!isInternational) {
    tabConfig.push(...REFUND_HISTORY_TAB);
    if (isWalletActive) {
      tabConfig.push(...DISPUTE_HISTORY_TAB);
    }
    if (isQrPaymentsEnabled) {
      tabConfig.push(...QR_PAYMENTS_TAB);
    }
  }

  return tabConfig;
};

export const formatGatewayNumber = (value) =>
  `Payment Method Excluded: ${GATEWAY_NUMBER_STRING[value]}`;

export const convertCustomerGSTInfoToAnswersFormat = (customGSTInfo) => {
  if (is_empty(customGSTInfo)) return {};
  const gstin = customGSTInfo.gst_number || customGSTInfo.gstin || "N/A";
  const gstName = customGSTInfo.company_name || customGSTInfo.gst_name || "N/A";
  const pinCode =
    customGSTInfo.company_pincode || customGSTInfo.pincode || "N/A";
  const gstCompanyAddress =
    customGSTInfo.company_address || customGSTInfo.gst_company_address || "N/A";
  const billingState = customGSTInfo.billing_state || "N/A";

  return {
    question: "GST",
    text_answer: JSON.stringify([
      {
        type: "gst_name",
        question: "Company name",
        is_visible: true,
        is_mandatory: true,
        answer: gstName,
      },
      {
        type: "gstin",
        disabled: true,
        question: "GST Number",
        is_visible: true,
        is_mandatory: true,
        answer: gstin,
      },
      {
        type: "gst_address",
        question: "Company address",
        is_visible: true,
        is_mandatory: true,
        answer: gstCompanyAddress || billingState,
      },
      {
        type: "gst_pincode",
        question: "Company pincode",
        is_visible: true,
        is_mandatory: true,
        answer: pinCode,
      },
    ]),
    multi_questions: null,
    type: question_type_id.GST,
  };
};
